export default "__VITE_ASSET__BmEby$6T__"